module.exports = __webpack_public_path__ + "static/img/36kr@2x.f8f4c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/customer/36kr@2x.png
// module id = 7vJa
// module chunks = 1